module.exports = __webpack_public_path__ + "fonts/daf914b5efc15cba89babc7466866c54.svg";